export default function convertHexToRGB(hexCode: string): { r: number; g: number; b: number } {
  let hex = hexCode.replace('#', '');
  if (hex.length === 3) hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  const [r, g, b] = [
    parseInt(hex.substring(0, 2), 16),
    parseInt(hex.substring(2, 4), 16),
    parseInt(hex.substring(4, 6), 16)
  ];
  return { r, g, b };
}

export function convertHexToRGBAString(hexCode: string, opacity?: number): string {
  const { r, g, b } = convertHexToRGB(hexCode);

  return opacity ? `rgba(${r}, ${g}, ${b}, ${opacity})` : `rgba(${r}, ${g}, ${b})`;
}
